<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <el-form :inline="true">
      <el-form-item>
        <el-input v-model="filters.key" placeholder="合同编号/工程/客户" @change="getSaleContract(1)"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="filters.Status" placeholder="请选择状态" @change="getSaleContract(1)">
          <el-option label="正常" :value="0"></el-option>
          <el-option label="已归档" :value="-100"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="filters.htStatus" placeholder="" @change="getSaleContract(1)">
          <el-option label="所有" :value="-1"></el-option>
          <el-option label="已签合同" :value="100"></el-option>
          <el-option label="未签合同" :value="-100"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getSaleContract(1)">查询</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table :data="saleContract" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%" height="600" :border="true">
      <el-table-column label="合同编号" width="155">
        <template slot-scope="scope">
          <el-link type="primary" @click="() => {
            currentRow = scope.row;
            handleDetail();
          }
            ">
            {{ scope.row.Code }}
          </el-link>
          <br />
          <el-link type="primary" @click="() => {
            currentRow = scope.row;
            handleHistry();
          }
            ">
            版本记录:{{ scope.row.ContractVer }}
            <el-tag :type="(scope.row.UploadUrl != null && scope.row.UploadUrl.length) > 5 ? 'success' : 'info'"
              disable-transitions>
              {{ (scope.row.UploadUrl != null && scope.row.UploadUrl.length > 5) ? "已签合同" : "未签合同" }}
            </el-tag>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="工程信息">
        <template slot-scope="scope">
          <p>{{ scope.row.ClientName }}</p>
          <p>{{ scope.row.ProjectName }}</p>
        </template>
      </el-table-column>
      <el-table-column label="生效日期" width="190">
        <template slot-scope="scope">
          <p>{{ scope.row.DateStart }} 至 {{ scope.row.DateEnd }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="ConsultPriceTitle" label="报价单" sortable></el-table-column>
      <el-table-column label="联系方式" width="190">
        <template slot-scope="scope">
          <p>营销:{{ scope.row.SalerName }}</p>
          <p>联系人:{{ scope.row.ContactName }}</p>
          <p>联系电话:{{ scope.row.ContactPhone }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注" sortable></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" sortable></el-table-column>
      <el-table-column prop="CreateUser" label="创建者" sortable></el-table-column>
      <el-table-column prop="Status" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status == 0 ? 'success' : 'info'" disable-transitions>
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="canEdit" type="primary" @click="() => {
            currentRow = scope.row;
            handleEdit();
          }
            ">
            编辑
          </el-link>
          <el-link v-if="canDelete" type="danger" @click="() => {
            sels.push(scope.row);
            handleDel();
          }
            ">
            删除
          </el-link>
          <el-link v-if="canFiled && scope.row.Status == 0" type="danger" @click="() => {
            currentRow = scope.row;
            handleFiled(-100);
          }
            ">
            归档
          </el-link>
          <el-link v-if="canFiled && scope.row.Status == -100" type="primary" @click="() => {
            currentRow = scope.row;
            handleFiled(0);
          }
            ">
            取消归档
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>

    <!--新增编辑界面-->
    <el-dialog width="90%" :title="isEdit ? '新增' : '编辑'" :visible.sync="editFormVisible" v-model="editFormVisible"
      :close-on-click-modal="false">
      <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
        <template>
          <el-tabs v-model="activeName">
            <el-tab-pane label="工程信息" name="one">
              <el-form-item label="客户名称">
                <el-input v-model="editForm.SaleContract.ClientName" class="input-clientname" style="width: 300px"
                  readonly />
                <el-button type="primary" @click="visibleDialog = true" :loading="editLoading">
                  选择
                </el-button>
              </el-form-item>
              <el-form-item label="工程名称">
                <template>
                  <el-select @change="projectSelectChanged" v-model="editForm.SaleContract.ProjectID" placeholder="请选择">
                    <el-option v-for="item in projectoptions" :key="item.Id + '_gc'" :label="item.ProjectName"
                      v-model="item.Id"></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item label="工程地址">
                <el-input v-model="editForm.SaleContract.ProjectAddress" style="width: 300px" readonly />
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="基础信息" name="two">
              <el-form :model="editForm" label-width="150px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="营销人员">
                      <el-col :span="20">
                        <el-input v-model="editForm.SaleContract.SalerName" readonly />
                      </el-col>
                      <el-col :span="1" :offset="1">
                        <el-button type="primary" @click="visibleSalerDialog = true" :loading="editLoading">
                          选择
                        </el-button>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="合同标题">
                      <el-input v-model="editForm.SaleContract.Title" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="联系人">
                      <el-input v-model="editForm.SaleContract.ContactName" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input v-model="editForm.SaleContract.ContactPhone" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="生效时间">
                  <el-date-picker type="datetime" placeholder="开始日期" v-model="editForm.SaleContract.DateStart"
                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  -
                  <el-date-picker type="datetime" placeholder="结束日期" v-model="editForm.SaleContract.DateEnd"
                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="结算方式">
                      <el-select v-model="editForm.SaleContract.PayType" placeholder="选择结算方式">
                        <el-option label="按方量结算" :value="10"></el-option>
                        <el-option label="按图纸结算" :value="20"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="结算类型">
                      <el-select v-model="editForm.SaleContract.SettlementType" placeholder="选择结算类型">
                        <el-option label="现结" :value="10"></el-option>
                        <el-option label="月结" :value="20"></el-option>
                        <el-option label="垫资" :value="30"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="合同性质">
                  <el-select v-model="editForm.SaleContract.ContractProperty" placeholder="合同性质">
                    <el-option label="临时合同" :value="10"></el-option>
                    <el-option label="担保合同" :value="20"></el-option>
                    <el-option label="正式合同" :value="30"></el-option>
                    <el-option label="加工合同" :value="40"></el-option>
                    <el-option label="协作合同" :value="50"></el-option>
                    <el-option label="现金合同" :value="60"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="选择产品" name="three">
              <el-form-item label="参考报价单">
                <el-input v-model="editForm.SaleContract.ConsultPriceTitle" style="width: 300px" readonly />
                <el-button type="primary" @click="visiblePriceDialog = true" :loading="editLoading">
                  选择
                </el-button>
              </el-form-item>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="对发货单生效">
                    <el-switch v-model="editForm.SaleContract.IsHistryEffect" active-color="#13ce66"
                      inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-button size="small" type="primary" @click="setzro()">
                    清零
                  </el-button>
                </el-col>
              </el-row>
              <el-form-item>
                <el-col :span="4">按比率调整：</el-col>
                <el-col :span="3" :offset="1">
                  <el-input placeholder="强度等级" v-model="editForm.SaleContract.GradeRate"></el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-input placeholder="特殊材料" v-model="editForm.SaleContract.SpecMtRate"></el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-input placeholder="浇筑方式" v-model="editForm.SaleContract.MethodRate"></el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-link type="primary" @click="() => {
                    RateChangeBase();
                  }
                    ">
                    基于原价调整
                  </el-link>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-link type="primary" @click="() => {
                    RateChangeNow();
                  }
                    ">
                    基于现价调整
                  </el-link>
                </el-col>
              </el-form-item>
              <el-form-item>
                <el-col :span="4">按数值调整：</el-col>
                <el-col :span="3" :offset="1">
                  <el-input placeholder="强度等级" v-model="editForm.SaleContract.GradeNumber"></el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-input placeholder="特殊材料" v-model="editForm.SaleContract.SpecMtNumber"></el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-input placeholder="浇筑方式" v-model="editForm.SaleContract.MethodNumber"></el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-link type="primary" @click="() => {
                    NumChangeBase();
                  }
                    ">
                    基于原价调整
                  </el-link>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-link type="primary" @click="() => {
                    NumChangeNow();
                  }
                    ">
                    基于现价调整
                  </el-link>
                </el-col>
              </el-form-item>
              <template>
                <el-table :data="editForm.SaleContractSubList" style="width: 100%">
                  <el-table-column label="产品类型" prop="DataTypeName" width="180"></el-table-column>
                  <el-table-column label="产品名称" prop="DataName" width="180"></el-table-column>
                  <el-table-column label="参考单价" prop="ConsultPrice" ></el-table-column>
                  <el-table-column label="实际单价">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.Price"></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-tab-pane>
            <el-tab-pane label="附加信息" name="four">
              <el-form-item label="付款条件">
                <el-input type="textarea" :rows="4" v-model="editForm.SaleContract.PayCondition"></el-input>
              </el-form-item>
              <el-form-item label="特殊要求">
                <el-input type="textarea" :rows="4" v-model="editForm.SaleContract.SpecialRequest"></el-input>
              </el-form-item>
              <el-form-item label="结算方式">
                <el-input type="textarea" :rows="4" v-model="editForm.SaleContract.PayTypeDesc"></el-input>
              </el-form-item>
              <el-form-item label="验收说明">
                <el-input type="textarea" :rows="4" v-model="editForm.SaleContract.AcceptRemark"></el-input>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="合同附件" name="five">
              <el-upload class="upload-demo" :action="uploadFile.uploadUrl" multiple :drag="true"
                :file-list="uploadFile.fileList" :on-success="uploadCallBack" :on-error="uploadCallBack"
                :on-preview="DownBmdCallBack" :on-remove="removeFile">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <!-- 合同详情 -->
    <el-dialog title="合同详情" :visible.sync="detailShow" v-model="detailShow" :close-on-click-modal="false" append-to-body
      width="90%">
      <el-form :model="editForm" label-width="120px">
        <el-divider content-position="left">
          合同概况 (合同编号：{{ editForm.SaleContract.Code }}；版本：{{
            editForm.SaleContract.ContractVer
          }})
        </el-divider>
        <table class="table-bordered" style="">
          <tr>
            <th>客户名称</th>
            <td>{{ editForm.SaleContract.ClientName }}</td>
            <th>工程名称</th>
            <td>{{ editForm.SaleContract.ProjectName }}</td>
          </tr>
          <tr>
            <th>工程地址</th>
            <td colspan="3">{{ editForm.SaleContract.ProjectAddress }}</td>
          </tr>
          <tr>
            <th>营销人员</th>
            <td>{{ editForm.SaleContract.SalerName }}</td>
            <th>起止时间</th>
            <td>
              {{ editForm.SaleContract.DateStart }}-{{
                editForm.SaleContract.DateEnd
              }}
            </td>
          </tr>
          <tr>
            <th>联系人</th>
            <td>{{ editForm.SaleContract.ContactName }}</td>
            <th>联系电话</th>
            <td>
              {{ editForm.SaleContract.ContactPhone }}
            </td>
          </tr>
          <tr>
            <th>结算方式</th>
            <td>
              {{
                editForm.SaleContract.PayType == 10
                  ? "按方量结算"
                  : editForm.SaleContract.PayType == 20
                    ? "按图纸结算"
                    : ""
              }}
            </td>
            <th>结算类型</th>
            <td>
              {{
                editForm.SaleContract.SettlementType == 10
                  ? "现结"
                  : editForm.SaleContract.SettlementType == 20
                    ? "月结"
                    : editForm.SaleContract.SettlementType == 30
                      ? "垫资"
                      : ""
              }}
            </td>
          </tr>
          <tr>
            <th>合同附件</th>
            <td colspan="3"> <el-upload :disabled="true" :action="uploadFile.uploadUrl" :on-preview="DownBmdCallBack"
                class="upload-demo" :file-list="uploadFile.fileList">

              </el-upload></td>
          </tr>
        </table>
      </el-form>
      <el-divider content-position="left">
        合同详情:报价单({{ editForm.SaleContract.ConsultPriceTitle }})
      </el-divider>
      <el-table :data="editForm.SaleContractSubList" border style="width: 100%">
        <el-table-column prop="DataTypeName" label="产品类型"></el-table-column>
        <el-table-column prop="DataName" label="产品名称"></el-table-column>
        <!-- <el-table-column prop="Quantity" label="数量"></el-table-column> -->
        <el-table-column prop="ConsultPrice" label="参考单价"></el-table-column>
        <el-table-column prop="Price" label="实际单价"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 历史合同列表 -->
    <el-dialog title="历史合同列表" :visible.sync="histryShow" v-model="histryShow" :close-on-click-modal="false"
      append-to-body>
      <!--历史列表-->
      <el-table :data="histryData" highlight-current-row v-loading="listLoading" style="width: 100%">
        <el-table-column label="合同编号" width="155">
          <template slot-scope="scope">
            <el-link type="primary" @click="() => {
              currentRow = scope.row;
              handleDetail();
            }
              ">
              {{ scope.row.Code }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="ProjectName" label="工程名称" sortable></el-table-column>
        <el-table-column prop="ClientName" label="客户名称" sortable></el-table-column>
        <el-table-column prop="ContractVer" label="版本号" sortable></el-table-column>
        <el-table-column prop="CreateUser" label="创建人" sortable></el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" sortable></el-table-column>
      </el-table>

      <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="histrypageSize" :total="histrytotal"
        @current-change="histryCurrentChange" @size-change="histrySizeChange" class="my-pagination"></el-pagination>
    </el-dialog>
    <TableDataDialog title="客户选择" :visibleDialog="visibleDialog" :queryMethod="queryData" :columns="{
      ClientName: {
        label: '客户名称',
      },
      Remark: {
        label: '备注',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="setVisible" @callback="dialogCallback"></TableDataDialog>
    <TableDataDialog title="营销人员选择" :visibleDialog="visibleSalerDialog" :queryMethod="querySalerData" :columns="{
      Name: {
        label: '人员名称',
      },
      Remark: {
        label: '备注',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="setSalerVisible" @callback="dialogSalerCallback"></TableDataDialog>
    <TableDataDialog title="参考报价单选择" :visibleDialog="visiblePriceDialog" :queryMethod="queryPriceData" :columns="{
      Title: {
        label: '报价单标题',
      },
      Remark: {
        label: '备注',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="setPriceVisible" @callback="dialogPriceCallback"></TableDataDialog>
  </section>
</template>

<script>
import { BaseApiUrl } from "../../api/api";
import * as api from "../../api/saleContract";
import { getClientListPage } from "../../api/client";
import { getHrEmployeeListPage } from "../../api/hrEmployee";
import {
  getConsultPriceListPage,
  getConsultPriceBaseData,
} from "../../api/consultPrice";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";

export default {
  components: { Toolbar, TableDataDialog },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        Status: 0,
        htStatus: -1,
      },
      saleContract: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {},
      //编辑界面数据
      editForm: {
        SaleContract: {}, //合同主表内容
        SaleContractSubList: [], //合同子表内容
      },
      visibleDialog: false, //客户选择
      visibleSalerDialog: false, //营销人员选择
      visiblePriceDialog: false, //参考报价单选择
      activeName: "one",
      projectoptions: [],
      isEdit: false,
      uploadFile: {
        fileList: [],
        uploadUrl: `${BaseApiUrl}/api/Upload/Uploadfile`,
      },
      detailShow: false,
      histryData: [], //合同历史记录
      histrytotal: 0, //合同历史记录翻页
      histrypage: 1,
      histrypageSize: 20,
      histryShow: false,
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex((s) => s.name === "编辑");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canFiled() {
      let index = this.buttonList.findIndex((s) => s.name === "归档");
      return index > -1;
    },
  },
  methods: {
    uploadCallBack(data) {
      this.uploadFile.fileList.push({
        name: data.response.split("\\")[1],
        url: data.response,
      });
    },
    DownBmdCallBack(data) {
      let fileName = "";
      let dataName = "";
      if (data && data.response && data.response.response) {
        fileName = data.response.response;
        dataName = decodeURI(data.config.params.filename);
      } else {
        fileName = data.url;
        dataName = data.name;
      }
      let para = {
        filename: fileName,
      };
      api.getFile(para).then((res) => {
        // 如果后端用encodeURI对文件名进行了编码，前端需用decodeURI进行解码（主要为处理特殊字符）
        //let fileName = decodeURI(data.headers.filename); // 由于ie不支持download属性，故需要做兼容判断
        let fileName = dataName; // 由于ie不支持download属性，故需要做兼容判断
        // let fileName = decodeURI(res.headers.filename); // 由于ie不支持download属性，故需要做兼容判断

        if (navigator.appVersion.toString().indexOf(".NET") > 0) {
          // ie独有的msSaveBlob属性，data.data为Blob文件流
          window.navigator.msSaveBlob(res.data, fileName);
        } else {
          let url = window.URL.createObjectURL(res.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      });
    },
    removeFile(data) {
      this.uploadFile.fileList.splice(
        this.uploadFile.fileList.indexOf(data),
        1
      );
    },
    handleRemove() {
      return false;
    },
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getSaleContract();
    },
    //获取客户列表
    getSaleContract(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      let para = {
        page: this.page,
        key: this.filters.key,
        status: this.filters.Status,
        intPageSize: this.pageSize,
        htStatus: this.filters.htStatus,
      };
      this.listLoading = true;
      api.getSaleContractListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.saleContract = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    histryCurrentChange() {
      this.page = val;
      this.getHistry();
    },
    //获取合同历史列表
    getHistry() {
      let para = {
        page: this.histrypage,
        key: this.currentRow.Code,
        intPageSize: this.histrypageSize,
      };
      this.listLoading = true;
      api.getHistryByPage(para).then((res) => {
        this.histrytotal = res.data.response.dataCount;
        this.histryData = res.data.response.data;
        this.listLoading = false;
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteSaleContract(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getSaleContract();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //归档
    handleFiled(status) {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      para.Status = status;
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .filedInfo(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getSaleContract();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //查看详情
    handleDetail() {
      this.uploadFile.fileList = [];
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });
        return;
      }
      let para = {
        id: row.Id,
      };
      api.getSaleContractDetailPage(para).then((res) => {
        //详情
        this.editForm = res.data.response;
        if (res.data.response.SaleContract.UploadUrl != null && res.data.response.SaleContract.UploadUrl.length > 0) {
          var UploadUrls = res.data.response.SaleContract.UploadUrl;
          this.uploadFile.fileList = JSON.parse(UploadUrls);
        }
        this.detailShow = true;
      });
    },
    //查看合同历史列表
    handleHistry() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });
        return;
      }
      this.histryShow = true;
      this.getHistry();
    },
    //显示编辑界面
    handleEdit() {
      this.uploadFile.fileList = [];
      this.activeName = "one";
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.isEdit = true;
      let para = {
        id: row.Id,
      };
      api.getSaleContractDetailPage(para).then((res) => {
        let para = {
          clientID: res.data.response.SaleContract.ClientID,
        };

        api.getProjectByClientPage(para).then((res1) => {
          this.projectoptions = res1.data.response.data;
          this.editForm = res.data.response;
          if (res.data.response.SaleContract.UploadUrl != null && res.data.response.SaleContract.UploadUrl.length > 0) {
            var UploadUrls = res.data.response.SaleContract.UploadUrl;
            this.uploadFile.fileList = JSON.parse(UploadUrls);
          }
        });
      });
    },
    //显示新增界面
    handleAdd() {
      this.activeName = "one";
      this.isEdit = false;
      this.editFormVisible = true;
      this.editForm = {
        SaleContract: {
          OrgId: JSON.parse(localStorage.user).OrgID,
          OrgCode: JSON.parse(localStorage.user).OrgCode,
          ContractProperty: 10,
          SettlementType: 20,
          ProjectID: null,
        }, //合同主表内容
        SaleContractSubList: [], //合同子表内容
      };
      this.uploadFile.fileList = [];
    },
    //执行编辑
    editSubmit() {
      if (this.uploadFile.fileList) {
        this.editForm.SaleContract.UploadUrl = JSON.stringify(
          this.uploadFile.fileList
        );
      }

      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;

          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            if (
              this.editForm.SaleContract.IsHistryEffect != undefined &&
              this.editForm.SaleContract.IsHistryEffect == 1
            ) {
              this.$confirm(
                "此操作将对" +
                this.editForm.SaleContract.DateStart +
                "到" +
                this.editForm.SaleContract.DateEnd +
                "是时间内发货单单价格进行修改,此操作可能耗时较久, 是否继续?",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              )
                .then(() => {
                  api
                    .editSaleContract(para)
                    .then((res) => {
                      if (res && res.data && res.data.success) {
                        this.$message({
                          message: res.data.msg,
                          type: "success",
                        });
                        this.$refs["editForm"].resetFields();
                      } else {
                        this.$message({
                          message: res.data.msg,
                          type: "error",
                        });
                      }
                    })
                    .finally(() => {
                      this.editLoading = false;
                      this.editFormVisible = false;
                      this.getSaleContract();
                    });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "操作取消",
                  });
                  this.editLoading = false;
                });
            } else {
              api
                .editSaleContract(para)
                .then((res) => {
                  if (res && res.data && res.data.success) {
                    this.$message({
                      message: res.data.msg,
                      type: "success",
                    });
                    this.$refs["editForm"].resetFields();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                    });
                  }
                })
                .finally(() => {
                  this.editLoading = false;
                  this.editFormVisible = false;
                  this.getSaleContract();
                });
            }
          } else {
            api
              .addSaleContract(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.editLoading = false;
                this.editFormVisible = false;
                this.getSaleContract();
              });
          }
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.getSaleContract(1);
    },
    //合同历史切换分页大小绑定方法
    histrySizeChange(size) {
      this.histrypageSize = size;
      this.getHistry();
    },
    /*客户选择*/
    dialogCallback(data) {
      if (data.length > 0) {
        this.editForm.SaleContract.ClientName = data[0].ClientName;
        this.editForm.SaleContract.ClientID = data[0].Id;
        this.editForm.SaleContract.ContactName = data[0].ContactPerson;
        this.editForm.SaleContract.ContactPhone = data[0].ContactPhone;
        let para = {
          clientID: data[0].Id,
        };
        api.getProjectByClientPage(para).then((res) => {
          this.projectoptions = res.data.response.data;
          if (res.data.response.data && res.data.response.data.length > 0) {
            var projectItem = res.data.response.data[0];
            if (projectItem) {
              this.editForm.SaleContract.ProjectAddress =
                projectItem.ProjectAddress;
              this.editForm.SaleContract.ProjectName = projectItem.ProjectName;
              this.editForm.SaleContract.ProjectID = projectItem.Id;
              this.editForm.SaleContract.Remark = projectItem.Remark;
            }
          }
        });
      }
      this.visibleDialog = false;
    },
    queryData(params) {
      return getClientListPage(params);
    },
    setVisible(val) {
      this.visibleDialog = val;
    },
    /*客户选择*/
    /*营销人员选择*/
    dialogSalerCallback(data) {
      if (data.length > 0) {
        this.editForm.SaleContract.SalerName = data[0].Name;
        this.editForm.SaleContract.SalerID = data[0].Id;
      }
      this.visibleSalerDialog = false;
    },
    querySalerData(params) {
      return getHrEmployeeListPage(params);
    },
    setSalerVisible(val) {
      this.visibleSalerDialog = val;
    },
    /*营销人员选择*/
    /*参考报价单选择*/
    dialogPriceCallback(data) {
      if (data.length > 0) {
        this.editForm.SaleContract.ConsultPriceTitle = data[0].Title;
        this.editForm.SaleContract.ConsultPriceID = data[0].Id;
        this.editForm.SaleContract.ConsultPriceCode = data[0].Code;

        let para = {
          id: data[0].Id,
        };
        getConsultPriceBaseData(para).then((res) => {
          var priceSubDataBase = [];
          res.data.response.map((e) => {
            priceSubDataBase = priceSubDataBase.concat(e.PriceSubDataBase);
          });
          this.editForm.SaleContractSubList = priceSubDataBase;
        });
      }
      this.visiblePriceDialog = false;
    },
    queryPriceData(params) {
      return getConsultPriceListPage(params);
    },
    setPriceVisible(val) {
      this.visiblePriceDialog = val;
    },
    /*工程选择*/
    projectSelectChanged(value) {
      var projectItem = this.projectoptions.filter((e) => e.Id == value);
      if (projectItem && projectItem.length > 0) {
        this.editForm.SaleContract.ProjectAddress =
          projectItem[0].ProjectAddress;
        this.editForm.SaleContract.ProjectName = projectItem[0].ProjectName;
        this.editForm.SaleContract.Remark = projectItem[0].Remark;
      }
    },
    setzro() {
      if (
        this.editForm.SaleContractSubList &&
        this.editForm.SaleContractSubList.length > 0
      ) {
        this.editForm.SaleContractSubList.map((k) => {
          k.Price = 0;
        });
      }
    },
    //基于原价百分比调整
    RateChangeBase() {
      if (
        this.editForm.SaleContractSubList &&
        this.editForm.SaleContractSubList.length > 0
      ) {
        var mainDM = this.editForm.SaleContract;
        var gradeRate =
          mainDM.GradeRate == "" || mainDM.GradeRate == undefined
            ? 0
            : Number(mainDM.GradeRate);

        var specMtRate =
          mainDM.SpecMtRate == "" || mainDM.SpecMtRate == undefined
            ? 0
            : Number(mainDM.SpecMtRate);
        var methodRate =
          mainDM.MethodRate == "" || mainDM.MethodRate == undefined
            ? 0
            : Number(mainDM.MethodRate);
        this.editForm.SaleContractSubList.map((e) => {
          //强度等级
          if (e.DataType == 0) {
            e.Price = (
              Number(e.ConsultPrice) +
              (Number(e.ConsultPrice) * gradeRate) / 100
            ).toFixed(2);
          }
          //特殊材料
          if (e.DataType == 10) {
            e.Price = (
              Number(e.ConsultPrice) +
              (Number(e.ConsultPrice) * specMtRate) / 100
            ).toFixed(2);
          }
          //浇筑方式
          if (e.DataType == 20) {
            e.Price = (
              Number(e.ConsultPrice) +
              (Number(e.ConsultPrice) * methodRate) / 100
            ).toFixed(2);
          }
        });
      }
    },
    //基于现价百分比调整
    RateChangeNow() {
      if (
        this.editForm.SaleContractSubList &&
        this.editForm.SaleContractSubList.length > 0
      ) {
        var mainDM = this.editForm.SaleContract;
        var gradeRate =
          mainDM.GradeRate == "" || mainDM.GradeRate == undefined
            ? 0
            : Number(mainDM.GradeRate);

        var specMtRate =
          mainDM.SpecMtRate == "" || mainDM.SpecMtRate == undefined
            ? 0
            : Number(mainDM.SpecMtRate);
        var methodRate =
          mainDM.MethodRate == "" || mainDM.MethodRate == undefined
            ? 0
            : Number(mainDM.MethodRate);
        this.editForm.SaleContractSubList.map((e) => {
          //强度等级
          if (e.DataType == 0) {
            e.Price = (
              Number(e.Price) +
              (Number(e.Price) * gradeRate) / 100
            ).toFixed(2);
          }
          //特殊材料
          if (e.DataType == 10) {
            e.Price = (
              Number(e.Price) +
              (Number(e.Price) * specMtRate) / 100
            ).toFixed(2);
          }
          //浇筑方式
          if (e.DataType == 20) {
            e.Price = (
              Number(e.Price) +
              (Number(e.Price) * methodRate) / 100
            ).toFixed(2);
          }
        });
      }
    },
    //基于原价数值调整
    NumChangeBase() {
      if (
        this.editForm.SaleContractSubList &&
        this.editForm.SaleContractSubList.length > 0
      ) {
        var mainDM = this.editForm.SaleContract;
        var gradeNumber =
          mainDM.GradeNumber == "" || mainDM.GradeNumber == undefined
            ? 0
            : Number(mainDM.GradeNumber);

        var specMtNumber =
          mainDM.SpecMtNumber == "" || mainDM.SpecMtNumber == undefined
            ? 0
            : Number(mainDM.SpecMtNumber);
        var methodNumber =
          mainDM.MethodNumber == "" || mainDM.MethodNumber == undefined
            ? 0
            : Number(mainDM.MethodNumber);
        this.editForm.SaleContractSubList.map((e) => {
          //强度等级
          if (e.DataType == 0) {
            e.Price = (Number(e.ConsultPrice) + gradeNumber).toFixed(2);
          }
          //特殊材料
          if (e.DataType == 10) {
            e.Price = (Number(e.ConsultPrice) + specMtNumber).toFixed(2);
          }
          //浇筑方式
          if (e.DataType == 20) {
            e.Price = (Number(e.ConsultPrice) + methodNumber).toFixed(2);
          }
        });
      }
    },
    //基于现价数值调整
    NumChangeNow() {
      if (
        this.editForm.SaleContractSubList &&
        this.editForm.SaleContractSubList.length > 0
      ) {
        var mainDM = this.editForm.SaleContract;
        var gradeNumber =
          mainDM.GradeNumber == "" || mainDM.GradeNumber == undefined
            ? 0
            : Number(mainDM.GradeNumber);

        var specMtNumber =
          mainDM.SpecMtNumber == "" || mainDM.SpecMtNumber == undefined
            ? 0
            : Number(mainDM.SpecMtNumber);
        var methodNumber =
          mainDM.MethodNumber == "" || mainDM.MethodNumber == undefined
            ? 0
            : Number(mainDM.MethodNumber);
        this.editForm.SaleContractSubList.map((e) => {
          //强度等级
          if (e.DataType == 0) {
            e.Price = (Number(e.Price) + gradeNumber).toFixed(2);
          }
          //特殊材料
          if (e.DataType == 10) {
            e.Price = (Number(e.Price) + specMtNumber).toFixed(2);
          }
          //浇筑方式
          if (e.DataType == 20) {
            e.Price = (Number(e.Price) + methodNumber).toFixed(2);
          }
        });
      }
    },
  },
  mounted() {
    this.getSaleContract();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style lang="less" scoped>
.input-clientname {
  width: 100px;
}
</style>
